import { CIRCULAR_UPDATES, CIRCULAR_UPDATES_ERROR, CIRCULAR_UPDATES_HIDE_ERROR, CIRCULAR_UPDATES_START_LOADER, CIRCULAR_UPDATES_STOP_LOADER, } from "@frameworks/web/redux/interfaces/StaticFooter/iCircularUpdate";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: undefined,
        isOpen: false,
    },
};
const CircularUpdateReducer = (state = initState, action) => {
    switch (action.type) {
        case CIRCULAR_UPDATES:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case CIRCULAR_UPDATES_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CIRCULAR_UPDATES_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CIRCULAR_UPDATES_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CIRCULAR_UPDATES_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default CircularUpdateReducer;
